import { Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { LayoutComponent } from './components/layout/layout.component';
import { EgiNavbarComponent } from './/components/egi-navbar/egi-navbar.component';
import { DashboardPageComponent } from './/pages/dashboard-page/dashboard-page.component';
import { EgiAppMenuComponent } from './/components/egi-app-menu/egi-app-menu.component';
import { LoginPageComponent } from './/pages/login-page/login-page.component';
import { RouterModule } from '@angular/router';
import { coreRoutes } from './routes';
import { EgiPageMenuComponent } from './components/egi-page-menu/egi-page-menu.component';
import { TypedClassProvider } from '@shared/ioc/typed-class-provider';
import { LAYOUT_ACTIONS, LAYOUT_QUERIES } from './/store/types';
import { LayoutStoreQueries } from './/store/layout-store.queries';
import { LayoutStoreActions } from './/store/layout-store.actions';
import { NavigationItemTreeModule } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-tree.module';
import { EgiPageFrameworkModule } from '@ervo/page-framework';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserModule } from '@core/../platform/platform-core/user/user.module';
import { PlatformInitializer } from '../platform/platform-core/platform-initializer';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from '@core/http-interceptors/loader-interceptor';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationItemWikiButtonComponent } from './components/navigation-item-wiki-button/navigation-item-wiki-button.component';
import { NOTIFIER, Notifier } from '@shared/notifier/types';
import { PlatformContextModule } from '@/app/platform/platform-context/platform.context.module';
import { ApplicationExitActionsComponent } from './components/application-exit-actions/application-exit-actions.component';
import { ApplicationInfoComponent } from './components/application-info/application-info.component';
import { APPLICATION_ACTIONS } from '@core/actions/types';
import { ApplicationActionsFacade } from '@core/actions/application-actions-facade';
import { EgiBreadcrumbComponent } from './components/egi-breadcrumb/egi-breadcrumb.component';
import { EgiAppCardComponent } from './components/egi-app-menu/egi-app-card/egi-app-card.component';
import { LayoutPortalDirective } from './portals/layout-portal.directive';
import { LayoutPortalService } from '@core/portals/layout-portal.service';
import { EPortalComponent } from './portals/e-portal/e-portal.component';
import { EgiNavigationItemComponent } from './components/egi-navigation-item/egi-navigation-item.component';
import { EgiNavbar2Component } from './components/egi-navbar2/egi-navbar2.component';
import {
  PlatformNotificationsModule
} from '@/app/platform/platform-core/platform-notifications/platform-notifications.module';
import { NavigationItemSearchComponent } from './components/navigation-item-search/navigation-item-search.component';
import { LayoutStandaloneComponent } from './components/layout-standalone/layout-standalone.component';
import { LanguageSelectorComponent } from './pages/public-account/language-selector/language-selector.component';
import { MultiLanguageModule } from '@/app/multi-language.module';
import { SupportPanelComponent } from '@/app/support/support-panel.component';
import { HdChartImportIndicatorComponent } from '@/app/human-design/chart/library/import/hd-chart-import-indicator.component';
import { AppUpdateIndicatorComponent } from '@core/app-update/app-update-indicator.component';
import { LiveConnectionIndicatorComponent } from '@core/live-connection/live-connection-indicator.component';

@NgModule({
  declarations: [
    LayoutComponent,
    EgiNavbarComponent,
    DashboardPageComponent,
    EgiAppMenuComponent,
    LoginPageComponent,
    EgiPageMenuComponent,
    NavigationItemWikiButtonComponent,
    ApplicationExitActionsComponent,
    ApplicationInfoComponent,
    EgiBreadcrumbComponent,
    EgiAppCardComponent,
    LayoutPortalDirective,
    EPortalComponent,
    EgiNavigationItemComponent,
    EgiNavbar2Component,
    NavigationItemSearchComponent,
    LayoutStandaloneComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    EgiPageFrameworkModule,
    PlatformContextModule,
    NavigationItemTreeModule,
    UserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatTreeModule,
    MatMenuModule,
    PlatformNotificationsModule,
    MultiLanguageModule,
    LanguageSelectorComponent,
    SupportPanelComponent,
    HdChartImportIndicatorComponent,
    AppUpdateIndicatorComponent,
    LiveConnectionIndicatorComponent
  ],
  exports: [LayoutPortalDirective],
  providers: [
    new TypedClassProvider(LAYOUT_QUERIES, LayoutStoreQueries),
    new TypedClassProvider(LAYOUT_ACTIONS, LayoutStoreActions),
    PlatformInitializer,
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: LoaderInterceptor
    },
    new TypedClassProvider(APPLICATION_ACTIONS, ApplicationActionsFacade),
    LayoutPortalService
  ]
})
export class CoreModule {
  static readonly routes = coreRoutes;

  constructor(
    @Inject(NOTIFIER)
    private readonly notifier: Notifier
  ) {}
}
